import {
  Button,
  Form,
  Modal,
  Card,
  Spin,
  message,
  InputNumber,
  Input,
  Typography,
  Divider,
  Upload,
  Empty,
  Image,
  Row,
  Col,
  Popconfirm,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import {
  HEADERS_EXPORT_BEN,
  HEADERS_UPIMAGE,
  POST_LAWSUIT_DETAIL,
  POST_CLEAR_PAYMENT,
  POST_UPLOAD_IMAGE_NEW,
  GET_LOAD_IMAGE_NEW_BY,
  GET_LOAD_IMAGE_NEW_ALL,
  POST_DELETE_IMAGE_NEW,
} from "../../../API/apiUrls";
import Dragger from "antd/es/upload/Dragger";
import {
  InboxOutlined,
  FilePdfOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import Compressor from "compressorjs";

const { TextArea } = Input;
const { Text } = Typography;

const ClearAdvancePaymentOnce = ({
  open,
  close,
  dataDefault,
  funcUpdateStatus,
}) => {
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const token = localStorage.getItem("TOKEN");

  const [loading, setLoading] = useState(false);
  const [dataRender, setDataRender] = useState([]);
  const [btnOn, setBtnOn] = useState(false);
  const [form] = Form.useForm();
  const [totalPay, setTotalPay] = useState({});
  const [fileListByContract, setFileListByContract] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [allImg, setAllImg] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [dataLoad, setDataload] = useState();
  const [selectedImages, setSelectedImages] = useState([]);

  const handleCancel = () => {
    close(false);
  };

  useEffect(() => {
    if (dataDefault && open) {
      console.log("dataDefault:", dataDefault);
      loadData();
      loadPath();
      form.resetFields();
      setFileListByContract({});
      setBtnOn(false);
      setAllImg([]);
    }
  }, [dataDefault, open]);

  // ============== LOAD DATA ==============
  const loadData = async () => {
    setLoading(true);

    try {
      const lawsuitRes = await axios.post(
        POST_LAWSUIT_DETAIL,
        {
          CONTNO: dataDefault.CONTNO,
          loanId: dataDefault.loanId,
          lawsuitId: dataDefault.lawsuitId,
        },
        {
          headers: HEADERS_EXPORT_BEN,
        },
      );

      const lawsuitData = lawsuitRes.data?.lawsuit;
      setDataload(lawsuitData);
      if (!lawsuitData) {
        message.warning("ไม่พบข้อมูล lawsuit");
        setDataRender([]);
        return;
      }

      console.log("Lawsuit Data:", lawsuitData);
      renderDataDetail(lawsuitData);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาดในการโหลดข้อมูล: ${error.message}`);
      setDataRender([]);
    } finally {
      setLoading(false);
    }
  };

  const loadPath = async () => {
    setLoading(true);
    try {
      const imgRes = await axios.get(
        `${GET_LOAD_IMAGE_NEW_ALL}/5/${dataDefault.loanId}`,
        {
          headers: HEADERS_UPIMAGE,
        },
      );

      const imgResData = imgRes.data;
      if (!imgResData) {
        message.warning("ไม่พบข้อมูล lawsuit");
        setFileListByContract([]);
        return;
      }

      console.log("imgResData Data:", imgResData);
      setFileListByContract(imgResData);
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`เกิดข้อผิดพลาดในการโหลดข้อมูล: ${error.message}`);
      setFileListByContract([]);
    } finally {
      setLoading(false);
    }
  };

  // ============== RENDER DATA DETAIL ==============
  const renderDataDetail = (lawsuitData) => {
    console.log("lawsuitData:", lawsuitData);

    // ดึง TMBILL จาก workExpenseList item แรก
    const workExpenseList = lawsuitData.workExpenseList || [];
    const tmbill = workExpenseList[0]?.TMBILL || "";

    const groupedArray = [
      {
        CONTNO: dataDefault.CONTNO,
        loanId: lawsuitData.loanId,
        lawsuitId: lawsuitData.lawsuitId,
        TMBILL: tmbill,
        expenses: workExpenseList,
      },
    ];

    setDataRender(groupedArray);
  };

  // ============== SEND DATA ==============
  const sendData = async (workExpenseList, payamtMark) => {
    if (workExpenseList.length === 0) {
      message.warning("กรุณากรอกข้อมูลอย่างน้อย 1 รายการ");
      return { success: false, error: "ไม่มีข้อมูล" };
    }

    const payload = {
      TMBILL: dataRender[0]?.TMBILL,
      payamtMark: payamtMark || null,
      clearStatus: null, // ร่างไว้ก่อน
      userId: userId,
      workExpenseList: workExpenseList,
    };

    console.log("Payload to send:", payload);

    try {
      const response = await axios.post(POST_CLEAR_PAYMENT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      if (response.status === 200 || response.status === 201) {
        return { success: true };
      } else {
        throw new Error("Unexpected response status");
      }
    } catch (error) {
      console.error("Error sending data:", error);
      const errorMsg = error.response?.data?.message || error.message;
      return { success: false, error: errorMsg };
    }
  };

  // ============== UPLOAD IMAGE ==============
  const handleUpLoadIMG = useCallback(async (resultImgs, menu, data) => {
    const newFormData = new FormData();

    try {
      newFormData.append("id", data.id);
      newFormData.append("notis", menu);

      const sortedImgs = resultImgs
        .filter((img) => img.originalIndex !== undefined)
        .sort((a, b) => {
          const typeDiff = a.type - b.type;
          if (typeDiff !== 0) return typeDiff;
          return a.originalIndex - b.originalIndex;
        });

      for (const file of sortedImgs) {
        newFormData.append("file", file.imageCompressedFile);
        newFormData.append("menuType", menu);
        newFormData.append("imageType", file.type);
      }

      const response = await axios.post(POST_UPLOAD_IMAGE_NEW, newFormData, {
        headers: HEADERS_UPIMAGE,
      });

      if (response.status === 200) {
        return { success: true, status: response.status };
      }

      return { success: false, error: "อัปโหลดรูปไม่สำเร็จ" };
    } catch (error) {
      console.error("Upload error:", error);
      return { success: false, error: error.message };
    }
  }, []);

  // ============== ON FINISH ==============
  const onFinish = async (values) => {
    console.log("Form values:", values);

    let workExpenseList = [];

    dataRender.forEach((loan) => {
      loan.expenses.forEach((expense) => {
        const payValue = values[`pay_${expense.id}`];

        workExpenseList.push({
          id: expense.id,
          TMBILL: expense.TMBILL,
          lawsuitId: expense.lawsuitId,
          expenseTypeId: expense.expenseTypeId,
          NETPAY: expense.NETPAY,
          NETPAY_DT: expense.NETPAY_DT,
          PAY:
            payValue !== undefined && payValue !== null
              ? payValue
              : parseFloat(expense.NETPAY) || 0, // ใช้ NETPAY ถ้าไม่มีค่า
          loanId: loan.loanId,
          CONTNO: loan.CONTNO,
        });
      });
    });

    console.log("workExpenseList to send:", workExpenseList);

    setLoading(true);
    try {
      const statusResult = await sendData(workExpenseList, values.memo);

      if (!statusResult.success) {
        throw new Error(statusResult.error);
      }
      console.log("✅ บันทึกข้อมูลสำเร็จ", statusResult);

      if (allImg?.length > 0) {
        console.log(`📤 กำลังอัปโหลดรูปภาพ ${allImg.length} ไฟล์...`);

        const uploadResult = await handleUpLoadIMG(allImg, 5, {
          id: dataDefault.loanId,
        });
        console.log(uploadResult);

        if (uploadResult.success) {
          console.log("✅ อัปโหลดรูปภาพสำเร็จ");
          message.success("บันทึกรูปสำเร็จ");
        } else {
          console.warn("⚠️ อัปโหลดรูปภาพล้มเหลว:", uploadResult.error);
          message.warning("บันทึกข้อมูลสำเร็จ แต่อัปโหลดรูปภาพล้มเหลว");
        }
      }

      if (funcUpdateStatus) {
        await funcUpdateStatus();
      }

      message.success({
        content: "เคลียร์เงินทดรองจ่ายสำเร็จ",
        duration: 2,
      });

      setTimeout(() => {
        handleCancel();
      }, 500);
    } catch (error) {
      console.error("❌ เกิดข้อผิดพลาด:", error);
      message.error(error.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลให้ครบถ้วน");
  };

  // ============== HANDLE INPUT CHANGE ==============
  const handleInputChange = (value, contno, expenseId) => {
    if (value !== null && value !== undefined) {
      setBtnOn(true);
    }

    setTotalPay((prevTotal) => {
      const loanData = dataRender.find((item) => item.CONTNO === contno);

      if (!loanData) return prevTotal;

      const newTotal = loanData.expenses.reduce((sum, expense) => {
        if (expense.id === expenseId) {
          return sum + (parseFloat(value) || 0);
        }
        const formValue = form.getFieldValue(`pay_${expense.id}`);
        if (formValue !== undefined && formValue !== null) {
          return sum + (parseFloat(formValue) || 0);
        }

        return sum;
      }, 0);
      console.log("newTotal", newTotal);

      return {
        ...prevTotal,
        [contno]: newTotal,
      };
    });
  };

  // ลบรูป (รับ array)
  const handleDeleteIMG = async (images) => {
    if (!images || images.length === 0) return;

    setLoading(true);
    try {
      // ✅ แก้ axios config - headers ต้องอยู่ใน object เดียวกับ data
      const res = await axios.delete(POST_DELETE_IMAGE_NEW, {
        data: images,
        headers: HEADERS_UPIMAGE,
      });

      if (res.status === 200) {
        const selectedPaths = new Set(images.map((img) => img.path));
        setFileListByContract((prev) =>
          prev.filter((img) => !selectedPaths.has(img.path)),
        );
        message.success("ลบรูปสำเร็จ");
      }
    } catch (err) {
      message.error("เกิดข้อผิดพลาด ลบรูปไม่สำเร็จ");
      console.error("err", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ ลบรูปเดียว - ส่งเป็น array
  const handleDeleteSingleImage = async (image) => {
    await handleDeleteIMG([image]);
  };

  // ✅ Helper function สำหรับ compress รูป
  const compressImage = async (file, types, index) => {
    return new Promise((resolve) => {
      let quality;
      if (file.size >= 2500000) quality = 0.1;
      else if (file.size >= 2000000) quality = 0.15;
      else if (file.size >= 1500000) quality = 0.2;
      else if (file.size >= 1000000) quality = 0.3;
      else quality = 0.5;

      new Compressor(file, {
        quality: quality,
        success: (result) => {
          const fileOptions = {
            type: result.type,
            lastModified: Date.now(),
          };
          const compressedFileAsFile = new File(
            [result],
            file.name,
            fileOptions,
          );

          const image = {
            imageCompressedFile: compressedFileAsFile,
            type: types,
            originalIndex: index,
          };

          setAllImg((prev) => [...prev, image]);
          setLoading(false);
          resolve(true);
        },
        error: (err) => {
          console.error("Compressor error:", err);
          message.error(`ไม่สามารถบีบอัดไฟล์ "${file.name}" ได้`);
          setLoading(false);
          resolve(true);
        },
      });
    });
  };

  // ✅ Preview รูป
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
      let pdfUrl = file.url;
      if (!pdfUrl && file.originFileObj) {
        pdfUrl = URL.createObjectURL(file.originFileObj);
      }
      window.open(pdfUrl, "_blank");
      return;
    }

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  // ✅ Handle change file list
  const handleChangeIMG = ({ fileList: newFileList, file }) => {
    const updatedFileList = newFileList.map((f) => {
      if (f.type === "application/pdf" || f.name.endsWith(".pdf")) {
        // Custom icon logic ถ้าต้องการ
      }
      return f;
    });

    setFileList(updatedFileList);

    if (file.status === "removed") {
      setAllImg((prevAllImg) => {
        return prevAllImg.filter((img) => img.originalIndex !== file.uid);
      });
    }

    if (
      file.status === "done" ||
      file.status === "removed" ||
      file.status === "error"
    ) {
      setLoading(false);
    }
  };

  // ✅ Before upload
  const beforeUpts = async (file, ty) => {
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      const image = {
        imageCompressedFile: file,
        type: ty,
        originalIndex: file.uid,
      };
      setAllImg((prev) => [...prev, image]);
      return false;
    }

    if (file.size > 5000000) {
      message.warning(`ไฟล์ "${file.name}" เกิน 5MB`);
      return Upload.LIST_IGNORE;
    }

    try {
      setLoading(true);
      await compressImage(file, ty, file.uid);
      return false;
    } catch (error) {
      console.error("File processing error:", error);
      message.error("File processing failed.");
      return Upload.LIST_IGNORE;
    }
  };

  // ✅ Upload Props
  const uploadProps = {
    name: "file",
    multiple: true,
    accept: "image/*,.pdf",
    listType: "picture",
    fileList: fileList,
    onPreview: handlePreview,
    onChange: handleChangeIMG,
    beforeUpload: (file) => beforeUpts(file, 4), //4 = ใบเสร็จศาล
    iconRender: (file) => {
      if (file.type === "application/pdf" || file.name.endsWith(".pdf")) {
        return (
          <FilePdfOutlined style={{ fontSize: "48px", color: "#ff4d4f" }} />
        );
      }
      return null;
    },
  };

  return (
    <Modal
      title={`เคลียร์เงินทดรองจ่าย ${dataRender[0]?.TMBILL || ""}`}
      open={open}
      onCancel={handleCancel}
      width={900}
      footer={null}
      destroyOnHidden
    >
      <Spin spinning={loading} size="large" tip="Loading...">
        <Card>
          {dataLoad?.workExpenseList?.length > 0 ? (
            <Form
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 16 }}
              layout="horizontal"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              style={{ maxWidth: 850 }}
              form={form}
            >
              {/* ============== แสดงแต่ละสัญญา ============== */}
              {dataRender?.map((loan, loanIndex) => {
                return (
                  <div
                    key={loan.CONTNO || loanIndex}
                    style={{
                      marginBottom: "20px",
                      border: "1px solid #ccc",
                      padding: "15px",
                      background:
                        loanIndex % 2 === 0
                          ? "linear-gradient(135deg, #f5f7fa 0%, #FFEBB7 100%)"
                          : "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                      borderRadius: "10px",
                      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div style={{ marginBottom: "15px" }}>
                      <Text strong style={{ fontSize: "16px" }}>
                        สัญญา: {loan.CONTNO}
                      </Text>
                      <Text type="secondary" style={{ marginLeft: "15px" }}>
                        เลขที่บิล: {loan.TMBILL}
                      </Text>
                    </div>

                    {/* รายการค่าใช้จ่าย */}
                    {loan.expenses?.map((expense) => (
                      <div
                        key={expense.id}
                        style={{
                          marginBottom: "10px",
                          padding: "15px",
                          background: "rgba(255, 255, 255, 0.5)",
                          borderRadius: "5px",
                        }}
                      >
                        <Form.Item
                          label={expense.description || "ไม่ระบุ"}
                          name={`pay_${expense.id}`}
                          style={{ marginBottom: "0" }}
                          initialValue={parseFloat(expense.PAY) || 0}
                        >
                          <InputNumber
                            suffix="บาท"
                            formatter={(value) =>
                              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                            size="large"
                            placeholder={`ยอดตั้งเบิก: ${expense.NETPAY || 0} บาท`}
                            style={{
                              width: "80%",
                              color: "black",
                            }}
                            onChange={(value) =>
                              handleInputChange(value, loan.CONTNO, expense.id)
                            }
                          />
                        </Form.Item>
                        <Text
                          type="secondary"
                          style={{ fontSize: "11px", paddingLeft: "10px" }}
                        >
                          ยอดตั้งเบิก:{" "}
                          {currencyFormatPoint(expense.NETPAY) || 0} บาท
                        </Text>
                      </div>
                    ))}

                    {dataRender?.map((loan, loanIndex) => {
                      // ✅ คำนวณ total จาก PAY (ถ้ามี) หรือ NETPAY
                      const total = loan.expenses.reduce((sum, item) => {
                        const payValue = parseFloat(item.PAY) || 0;
                        return sum + payValue;
                      }, 0);
                      return (
                        <div key={loan.CONTNO || loanIndex} /* ... */>
                          {/* ... รายการค่าใช้จ่าย ... */}

                          {/* ยอดรวม */}
                          <Form.Item label="รวม" style={{ marginTop: "10px" }}>
                            <InputNumber
                              suffix="บาท"
                              // ✅ ถ้า totalPay มีค่า (user เปลี่ยน) ใช้ totalPay, ไม่งั้นใช้ total ที่คำนวณ
                              value={totalPay[loan.CONTNO] ?? total}
                              formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, "")
                              }
                              style={{
                                width: "50%",
                                color: "#1890ff",
                                fontWeight: "bold",
                                fontSize: "16px",
                              }}
                              size="large"
                              disabled
                            />
                          </Form.Item>
                        </div>
                      );
                    })}

                    {/* อัปโหลดใบเสร็จ */}
                    <Form.Item
                      label="อัปโหลดใบเสร็จศาล"
                      name="file"
                      rules={[
                        {
                          required: true,
                          message: "กรุณาอัปโหลดไฟล์คำพิพากษา !",
                        },
                      ]}
                    >
                      <Dragger
                        {...uploadProps}
                        style={{ width: "100%", height: "120px" }}
                      >
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined
                            style={{ color: "blue", fontSize: "32px" }}
                          />
                        </p>
                        <strong
                          className="ant-upload-text"
                          style={{ fontSize: "12px" }}
                        >
                          อัปโหลดใบเสร็จศาลสำหรับสัญญา {loan.CONTNO}
                        </strong>
                      </Dragger>
                    </Form.Item>

                    <Spin spinning={loading} size="large" tip="Loading...">
                      <Row gutter={[8, 8]} justify="center">
                        {fileListByContract
                          .filter((e) => e?.imageType === 4)
                          .map((e, index) => {
                            const isPdf = e.path
                              ?.toLowerCase()
                              .endsWith(".pdf");

                            return (
                              <Col
                                key={e.path || index}
                                xs={12}
                                sm={8}
                                md={6}
                                lg={6}
                                xl={6}
                              >
                                <div
                                  style={{
                                    position: "relative",
                                    width: "100%",
                                    textAlign: "center",
                                  }}
                                >
                                  {/* ปุ่มลบแบบ Icon */}
                                  <Popconfirm
                                    title="ยืนยันการลบ"
                                    description="ต้องการลบรูปภาพนี้?"
                                    onConfirm={() => handleDeleteSingleImage(e)}
                                    okText="ลบ"
                                    cancelText="ยกเลิก"
                                    okButtonProps={{ danger: true }}
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        zIndex: 10,
                                        width: 24,
                                        height: 24,
                                        borderRadius: "50%",
                                        backgroundColor:
                                          "rgba(255, 77, 79, 0.9)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <DeleteOutlined
                                        style={{ color: "#fff", fontSize: 12 }}
                                      />
                                    </div>
                                  </Popconfirm>

                                  <Card
                                    hoverable
                                    style={{
                                      width: "100%",
                                      textAlign: "center",
                                      padding: "8px",
                                    }}
                                  >
                                    {isPdf ? (
                                      <div
                                        onClick={() =>
                                          window.open(
                                            `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                            "_blank",
                                          )
                                        }
                                        style={{
                                          height: "120px",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          cursor: "pointer",
                                          backgroundColor: "#f0f0f0",
                                          borderRadius: "8px",
                                          border: "1px solid #d9d9d9",
                                        }}
                                      >
                                        <FilePdfOutlined
                                          style={{
                                            fontSize: "40px",
                                            color: "#ff4d4f",
                                          }}
                                        />
                                        <span
                                          style={{
                                            marginTop: "8px",
                                            fontSize: "12px",
                                            color: "#666",
                                          }}
                                        >
                                          คลิกเพื่อเปิด PDF
                                        </span>
                                      </div>
                                    ) : (
                                      <Image
                                        width="100%"
                                        height="120px"
                                        src={`${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`}
                                        alt={`รูปภาพ ${index}`}
                                        style={{
                                          objectFit: "cover",
                                          borderRadius: "8px",
                                        }}
                                        preview={{
                                          src: `${GET_LOAD_IMAGE_NEW_BY}/${e.path}?token=${token}`,
                                        }}
                                      />
                                    )}
                                  </Card>
                                </div>
                              </Col>
                            );
                          })}
                      </Row>
                    </Spin>
                  </div>
                );
              })}

              <Divider />
              {/* ============== หมายเหตุ ============== */}
              <Form.Item label="หมายเหตุ" name="memo" style={{ width: "100%" }}>
                <TextArea rows={4} placeholder="ระบุหมายเหตุ (ถ้ามี)" />
              </Form.Item>

              {/* ============== ปุ่ม ============== */}
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <Button
                  onClick={handleCancel}
                  size="large"
                  style={{ marginRight: "20px" }}
                >
                  ปิด
                </Button>
                <Button type="primary" size="large" htmlType="submit">
                  บันทึก
                </Button>
              </div>
            </Form>
          ) : (
            <Empty />
          )}
        </Card>
      </Spin>
    </Modal>
  );
};

export default ClearAdvancePaymentOnce;
